import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Typography} from '@material-ui/core';

import AfficheImage from 'components/Shared/AfficheImage';

import Context from 'utils/Context';

import './VODCard.scss';

function VODCard({vod, cinemaId, isRent}) {
  const {t} = useTranslation();
  const {goTo} = useContext(Context);

  const goToMovie = () => goTo(`/cinema/${cinemaId}/${vod.film?.id}`);

  return (
    <div className="FilmSchedule-container">
      <div className="FS-cover-container" onClick={() => goToMovie()}>
        <AfficheImage affiche={vod.film?.affiche} />
      </div>
      <div className="FilmWR-title">{vod.film?.name}</div>
      <Typography className="FilmWR-synopsis">{vod.film?.synopsis}</Typography>
      <div className="FilmWR-infos" onClick={() => goToMovie()}>
        {t("+ d'infos")}
      </div>
      <Button className="rent-button" onClick={() => goToMovie()}>
        {t(isRent ? 'voir-le-film' : 'louer')}
      </Button>
    </div>
  );
}

export default VODCard;
